const { useState, useEffect } = React;

const useWPOptionQuery = (key, { type = "string" } = {}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    wp.api.loadPromise.then(() => {
      const settings = new wp.api.models.Settings();
      settings.fetch().then((response) => {
        setData(prepareData(response[key], type));
        setIsLoading(false);
      });
    });
  }, []);

  const prepareData = (data, type) => {
    let newData = data;
    try {
      newData = JSON.parse(data);
    } catch (error) {}
    // if (type === "object") {
    // }
    return newData;
  };

  return { data, isLoading, isError, error };
};

export default useWPOptionQuery;
